export const query = new URLSearchParams(window.location.search)
export const has = (key: string) => query.has(key) || ''
export const get = (key: string) => query.get(key) || ''
export default query

